export default "../static/assets/icon-25c81dcb04bb17fa0e8ad26da31ac22b.png";